import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { MoonIcon } from 'lucide-react';
export function OpeningHook() {
  return <SectionWrapper className="bg-brand-surface/50" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <div className="flex items-center justify-center mb-8" data-id="element-128">
          <MoonIcon className="w-8 h-8 text-brand-terracotta mr-3" data-id="element-129" />
          <span className="font-serif text-2xl font-semibold text-brand-terracotta tracking-wider" data-id="element-130">
            3:14 AM
          </span>
        </div>

        <div className="border-l-4 border-brand-terracotta pl-6 md:pl-10 py-2" data-id="element-131">
          <p className="font-serif text-xl md:text-2xl leading-relaxed text-brand-brown mb-6 italic" data-id="element-132">
            Estás sentada en la orilla de la cama, con la pijama empapada en
            sudor y el corazón latiendo a mil por hora. No puedes volver a
            dormir, y lo peor es que sabes que en pocas horas tienes que
            levantarte para enfrentar el trabajo, la familia y el cansancio que
            ya no soportas.
          </p>
          <p className="font-sans text-lg md:text-xl leading-relaxed text-brand-brown/90" data-id="element-133">
            Sientes que tu cuerpo te ha traicionado. Que la mujer energética y
            enfocada que eras se ha perdido entre ataques de calor, olvidos
            repentinos y una irritabilidad que no puedes controlar.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}